import React, { useState } from 'react';
import api from '../api';

export default function DocumentList({ docs, buildingAddress, buildingNumber, apartmentNumber, onRefresh }) {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ documentName: '', documentPath: '', documentType: '' });

  async function handleAdd(e) {
    e.preventDefault();
    await api.post('/documents', {
      buildingAddress,
      buildingNumber,
      apartmentNumber,
      ...form
    });
    setShowForm(false);
    setForm({ documentName: '', documentPath: '', documentType: '' });
    onRefresh();
  }

  async function handleDelete(docName) {
    if (!window.confirm('למחוק את המסמך?')) return;
    await api.delete(`/documents/${buildingNumber}/${encodeURIComponent(docName)}`);
    onRefresh();
  }

  return (
    <div>
      <div className="actions-row">
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>+ הוסף מסמך</button>
      </div>
      {showForm && (
        <form onSubmit={handleAdd} className="inline-form" style={{ marginBottom: 16 }}>
          <div className="inline-form-row">
            <div className="form-group">
              <label>שם מסמך</label>
              <input value={form.documentName} onChange={e => setForm({ ...form, documentName: e.target.value })} required />
            </div>
            <div className="form-group">
              <label>נתיב</label>
              <input value={form.documentPath} onChange={e => setForm({ ...form, documentPath: e.target.value })} />
            </div>
            <div className="form-group">
              <label>סוג</label>
              <input value={form.documentType} onChange={e => setForm({ ...form, documentType: e.target.value })} />
            </div>
            <button type="submit" className="btn btn-primary">שמור</button>
            <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>ביטול</button>
          </div>
        </form>
      )}
      {docs.length === 0 ? (
        <p>אין מסמכים</p>
      ) : (
        <table>
          <thead><tr><th>שם</th><th>סוג</th><th>נתיב</th><th>פעולות</th></tr></thead>
          <tbody>
            {docs.map((d, i) => (
              <tr key={i}>
                <td>{d.documentName}</td>
                <td>{d.documentType}</td>
                <td>{d.documentPath}</td>
                <td><button className="btn btn-danger" onClick={() => handleDelete(d.documentName)}>מחק</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
